import api from "../../APIIntercepter";

async function saveMessageAPI(params) {
  const res = await api.post("/message/admin", params);
  return res.data;
}

async function sendMessageAPI(id) {
  const res = await api.post(`/message/admin/send?id=${id}`);
  return res.data;
}

export { saveMessageAPI, sendMessageAPI };
